module.exports = __webpack_public_path__ + "img/B4-20190410_02.2f39d370.jpg";